import { SET_CUSTOMER_ACTIVE } from '../action-types';

export const customerActiveReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case SET_CUSTOMER_ACTIVE: {
      return {
        ...action.payload
      };
    }
    default:
      return state;
  }
};
